import { environment as defaultEnvironment } from './environment';

export const envLoader = new Promise<any>((resolve, reject) => {

  console.log('resolving environment');

  const method = 'GET';
  const url = './assets/environments/environment.json';
  const xmlhttp = new XMLHttpRequest();

  xmlhttp.responseType = 'json';
  xmlhttp.open(method, url, true);
  xmlhttp.onload = () => {
    if (xmlhttp.status === 200) {
      // console.log('environment found');
      resolve(xmlhttp.response);
    } else {
      // console.log('falling back to default environment');
      resolve(defaultEnvironment);
    }
  };
  xmlhttp.send();
});
